<template src="./preventivo.html"></template>


<script>
import DialogDettaglio from "@/components/dialog/preventivi/DettaglioPrev";

import {
  get_modelli,
  get_tabellaDettaglio,
  set_testata,
  get_datiTestata,
  set_posizione,
  del_dettaglioPreventivo,
  dup_RigoDettaglio,
} from "@/api/api.preventivi.js";
import { get_profiloUtente } from "@/api/api.user.js";

export default {
  data: () => ({
    page: 1,
    pageCount: 0,
    itemsPerPage: 999,

    tabs: null,
    datiTestata: {},
    datiDettaglio: [],
    datiVociExtra: [],
    datiAllegati: [],
    //datiCollezione: [],
    datiModello: [],
    varianti: [],
    numPrev: 0, //numero del preventivo passato dalla view ListaPreventivi

    datiTabella: [{ NumPrev: "" }],
    selectedRow: [],

    textRules: [(v) => !!v || "Il campo è obbligatorio"],
    numericRules: [
      (v) => !!v || "Obbligatorio",
      (v) => v != 0 || "Obbligatorio",
    ],
    dialogDett: false,

    tooltipNoteShow: false,
    CodCollezione: "Speedy",
    dataOggi: "",

    //tabella elenco
    headersDettaglio: [
      { text: "Pos.", value: "DescPosizione" },
      /* { text: "", value: "", sortable: false },
      { text: " ", value: "", sortable: false }, */
      { text: " Modello ", value: "Modello" }, //todo update
      { text: "Q.tà", value: "Quantita" },
      { text: "H", value: "H" },
      { text: "L", value: "L" },
      { text: "S", value: "S" },
      { text: "Colore Anta", value: "ColoreAnta" },
      { text: "Colore Telaio", value: "ColoreTelaio" },
      { text: "Apertura", value: "Apertura" },
      { text: "Prezzo", value: "Prezzo" },
      { text: "", value: "", sortable: false },
    ],
    azione: "nuovo",
    colorSalva: "black",
    datiUtente: {},

    pagination: {
      sortBy: "posizione",
      rowsPerPage: "100",
      descending: true,
    },
    prezziVis: false,
    testoMostraPrezzi: "Mostra",
    testoIva: "\n+iva",

    smartphone: false,
    seeRightMenu: true,
  }),

  components: {
    DialogDettaglio,
  },

  methods: {
    async salvaDatiTestata() {
      var datiT = {
        id: this.numPrev,
        data: this.dataOggi,
        dataModifica: this.dataOggi,
        idUtente: this.datiUtente.IdUtente,
        codCliente: this.datiUtente.Codice,
        rifCliente: this.datiTestata.Riferimento,
        note: this.datiTestata.Note,
        sconto: 0,
        collezione: this.CodCollezione.toString(),
        pagamento: this.datiTestata.Pagamento,
        notePagamento: this.datiTestata.NotePagamento,
      };
      //agiungere controlli su utente e cliente
      let res = await set_testata(datiT);
      return res.data;
    },

    async avviaComando(comando) {
      // Controllo numero

      if (this.tabs == 0) {
        // Dettaglio
        if ((await this.salvaDatiTestata()) == "NO") {
          this.dialogDett = false;
          this.$toast.error("Errore");
          return;
        }
        this.scheda = 1;
        switch (comando) {
          case "nuovo":
            this.progDett = 0;
            this.selectedRow = [];
            if (
              this.datiTestata.Riferimento == null ||
              this.datiTestata.Riferimento == "" ||
              this.CodCollezione == null ||
              this.CodCollezione == ""
            ) {
              this.$toast.error("Compila tutti i campi e riprova!");
              break;
            }

            //nuovo rigo in PRE_dettaglio
            if ((await this.aggiungiRigoPreve()) == "NO") {
              this.dialogDett = false;
              this.$toast.error(
                "Impossibile aggiungere la posizione. Ricaricare la pagina"
              );
              return;
            }

            this.caricaModelli(this.CodCollezione);
            this.azione = "nuovo";
            this.dialogDett = true;
            break;

          case "modifica":
            if (!this.controllaRiga()) return;
            await this.caricaModelli(this.CodCollezione);
            this.azione = "modifica";
            // Apro la dialog
            this.dialogDett = true;

            break;

          case "elimina":
            if (!this.controllaRiga()) return;

            this.eliminaRigoDettaglio();
            break;

          case "duplica":
            if (!this.controllaRiga()) return;

            this.duplicaRigoDettaglio();
            break;
        }
      } else if (this.tabs == 1) {
        // Note
        switch (comando) {
          case "salva":
            this.salvaNote();
            break;
        }
      }
    },

    async aggiungiRigoPreve() {
      //controllo sul numero preventivo
      if (this.numPrev <= 0) this.numPrev = this.getPagePreve();
      var stringaDati = {
        id: this.numPrev,
        pos: 0,
        modello: "",
        mantovana: "",
        maniglia: "",
        maniglietta: "",
        quantita: 0,
        H: 2100,
        L: 0,
        S: 0,
        ColoreAnta: "",
        Apertura: "",
        tipoTelaio: "",
        ColoreTelaio: "",
        tipoCoprifilo: "",
        riferimento: "",
        noteRigo: "",
      };
      let res = await set_posizione(stringaDati);
      return res.data;
    },

    async eliminaRigoDettaglio() {
      let confirm = await this.$root.$confirm(
        "Elimina",
        "Vuoi eliminare il dettaglio ?"
      );
      if (!confirm) return;

      let res = await del_dettaglioPreventivo(
        this.numPrev,
        this.selectedRow.posizione
      );
      if (res.data != "OK") {
        this.$toast.error("Impossibile eliminare il dettaglio!");
      } else {
        this.$toast.warning("Dettaglio eliminato!");
        this.refresh();
      }
      this.close();
    },

    close() {
      this.$emit("close");
    },

    async salvaNote() {
      var datiT = {
        id: this.numPrev,
        data: this.dataOggi,
        dataModifica: this.dataOggi,
        idUtente: this.datiUtente.IdUtente,
        codCliente: this.datiUtente.Codice,
        rifCliente: this.datiTestata.Riferimento,
        note: this.datiTestata.Note,
        sconto: 0,
        collezione: this.CodCollezione.toString(),
        pagamento: this.datiTestata.Pagamento,
        notePagamento: this.datiTestata.NotePagamento,
      };
      //agiungere controlli su utente e cliente
      let res = await set_testata(datiT);
      if (res.data.isNull || res.data.isNaN || res.data == "NO") {
        this.$toast.error("Errore salvataggio note!");
      }
    },

    closeDialogDettaglio(aggiorna) {
      this.dialogDett = false;
      this.refresh();
    },

    controllaRiga() {
      if (this.tabs == 0) {
        // Dettaglio
        if (this.progDett != 0 && this.progDett != undefined) return true;
      }
      this.$toast.warning("Nessuna riga selezionata");
      return false;
    },

    refresh() {
      this.numPrev = this.getPagePreve();
      this.caricaDati(this.numPrev);
      this.$store.commit("app/SET_REFRESHDATI", false);
    },

    prevPage() {
      this.$router.push({
        path: "preventivi",
      });
    },

    controllaNumero() {
      if (!!this.numPrev == false) {
        this.$toast.info("Nessun numero selezionato");
        return false;
      }
      return true;
    },

    caricaDati(idPreventivo) {
      this.$root.$wait.open();
      this.pulisciOrdine();
      this.caricaDatiTestata(idPreventivo);
      this.$root.$wait.close();
    },

    async duplicaRigoDettaglio() {
      this.azione = "duplica";
      await dup_RigoDettaglio(
        this.selectedRow,
        this.numPrev,
        this.selectedRow.posizione
      );
      this.$toast.info("Riga duplicata");
      this.refresh();
      // Apro la dialog
      /* this.dialogDett = true; */
    },

    pulisciOrdine() {
      this.azione = "";
      this.datiTestata = [];
      this.datiTestata.Note = "";
      this.datiDettaglio = [];
      this.datiVociExtra = [];
      this.datiTabella = [];
      this.scheda = 1;
      this.progDett = 0;
      this.selectedRow = [];
      this.dataOggi = this.$i2kFunctions.formatDate_IT(new Date());
    },

    async caricaModelli(codColl) {
      this.datiModello = [];
      let res = await get_modelli(codColl);
      this.datiModello = res.data;
      this.fineCaricamentoOrdine();
    },

    async caricaDatiTestata(idPreventivo) {
      this.datiTestata = [];
      let res = await get_datiTestata(idPreventivo, this.datiUtente.IdUtente);
      if (res.data == null) {
        this.redirectBeforePage();
        return;
      }

      this.datiTestata.numUtente = res.data.idUtente;
      this.datiTestata.Data = res.data.data.substring(0, 10);
      this.datiTestata.Riferimento = res.data.rifCliente;
      this.datiTestata.Note = res.data.note;
      this.CodCollezione = res.data.collezione.toString();
      this.datiTestata.Importo = res.data.Importo;
      this.datiTestata.Pagamento = res.data.pagamento;
      this.datiTestata.NotePagamento = res.data.notePagamento;
      //carica la tabella dei dettagli del preventivo
      this.caricaTabellaDettaglio(res.data.id);

      this.loadingDati = false;
    },

    async caricaTabellaDettaglio(numP) {
      this.loadingDati = true;
      this.selectedRow = [];
      let res = await get_tabellaDettaglio(numP);
      this.datiTabella = res.data;
      this.loadingDati = false;
    },

    selectRow(props) {
      this.selectedRow = props;
      this.progDett = props.posizione;
    },

    fineCaricamentoOrdine() {
      setTimeout(() => {
        this.$root.$wait.close();
      }, 300);
    },

    getPagePreve() {
      if (this.$store.getters["app/getNumPreve"] <= 0) {
        this.redirectBeforePage();
        return;
      }
      return this.$store.getters["app/getNumPreve"];
    },

    async caricaDatiProfilo() {
      let par = "";
      let userSwitch = this.$store.getters["user/getUserSwitch"];
      if (userSwitch.Codice) par = userSwitch.Tipo + "/" + userSwitch.Codice;

      let res = await get_profiloUtente(par);
      this.datiUtente = res.data.Profilo;
    },

    mostraPrezzi() {
      this.prezziVis = !this.prezziVis;
    },

    visualizzaMenu() {
      this.seeRightMenu = !this.seeRightMenu;
    },

    SalvaNoteTestata() {
      this.salvaDatiTestata();
    },

    redirectBeforePage() {
      window.location.pathname = "/preventivi";
    },
  },

  async mounted() {
    this.numPrev = this.getPagePreve();
    this.dataOggi = this.$i2kFunctions.formatDate_IT(new Date());

    await this.caricaDatiProfilo();
    await this.caricaDatiTestata(this.numPrev);
  },

  created() {
    this.$store.commit("app/SET_PAGEPREVE", "/preventivo");
    this.smartphone = this.$i2kFunctions.isSmartphone();
    this.seeRightMenu = !this.smartphone;
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.keyEvent);
  },

  computed: {
    getRefreshDati() {
      return this.$store.getters["app/getRefreshDati"];
    },
  },

  watch: {
    prezziVis: function (newV, oldV) {
      if (newV) this.testoMostraPrezzi = "Nascondi";
      else this.testoMostraPrezzi = "Mostra";
    },

    getRefreshDati(newVal) {
      if (newVal != true) return;
      this.refresh();
    },
  },
};
</script>

<style scoped src="../../assets/styles/preventivo.css"></style>